import Api from "../../../../service";
import {
  RESET_COMPETITIONSPONSORS,
  SET_COMPETITIONSPONSORS,
  SET_ERROR,
} from "./constants";

const setCompetitionSponsors = (data) => ({
  type: SET_COMPETITIONSPONSORS,
  data,
});

const setError = (data) => ({
  type: SET_ERROR,
  data,
});

export const getCompetitionSponsors = (data) => (dispatch) =>
  Api.competition
    .getCompetitionSponsors(data)
    .then((response) => {
      dispatch(setCompetitionSponsors(response));
      return response;
    })
    .catch((error) => {
      console.error(error);
      dispatch(setError(error));
    });

export const resetCompetitionSponsors = (data) => ({
  type: RESET_COMPETITIONSPONSORS,
  data,
});
